import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getVehiclesByRegistration } from 'app/vehicles/state/actions'
import { EmptyUUID } from '@cbgms/base/utils/uuid'
import { Timing } from '@cbgms/base/utils/timing'
import { duplicateVehicleModalQueryParam, duplicateVehicleUUIDQueryParam } from 'app/vehicles/components/DuplicateVehicleFound/const'
import { useDebouncedCallback } from 'use-debounce'
import { useHistory } from 'react-router-dom'

export const useIsDuplicateRegistration = (country: string, registration: string) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const enteredRegistration = `${country}|${registration}`
  const [duplicateUUID, setDuplicateUUID] = useState(EmptyUUID)

  const showDuplicateRegistrationModal = useCallback(() => {
    const url = new URL(window.location.href)
    url.searchParams.append(duplicateVehicleModalQueryParam, '1')
    url.searchParams.append(duplicateVehicleUUIDQueryParam, duplicateUUID)
    history.replace(url.pathname + url.search)
  }, [duplicateUUID])

  const checkDuplicate = async (enteredRegistration: string) => {
    const { Data: vehicles } = await dispatch(getVehiclesByRegistration(enteredRegistration))
    if (vehicles.length) {
      setDuplicateUUID(vehicles[0].Vehicle.UUID)
    }
  }
  const debouncedCheckDuplicate = useDebouncedCallback(checkDuplicate, Timing.keyboardInput)

  useEffect(() => {
    setDuplicateUUID(EmptyUUID)
    if (!registration) {
      return
    }
    debouncedCheckDuplicate(enteredRegistration)
  }, [enteredRegistration])

  return { isDuplicateRegistration: duplicateUUID !== EmptyUUID, showDuplicateRegistrationModal }
}
